import React from 'react';
import { LucideIcon } from 'lucide-react';

const StatCard = ({ 
  title, 
  value, 
  icon: Icon, 
  color = 'blue', 
  trend, 
  trendValue, 
  subtitle,
  className = '',
  onClick 
}) => {
  const colorClasses = {
    blue: {
      bg: 'bg-blue-50',
      icon: 'text-blue-600',
      border: 'border-blue-200',
      accent: 'border-l-blue-500'
    },
    green: {
      bg: 'bg-green-50',
      icon: 'text-green-600',
      border: 'border-green-200',
      accent: 'border-l-green-500'
    },
    yellow: {
      bg: 'bg-yellow-50',
      icon: 'text-yellow-600',
      border: 'border-yellow-200',
      accent: 'border-l-yellow-500'
    },
    purple: {
      bg: 'bg-purple-50',
      icon: 'text-purple-600',
      border: 'border-purple-200',
      accent: 'border-l-purple-500'
    },
    red: {
      bg: 'bg-red-50',
      icon: 'text-red-600',
      border: 'border-red-200',
      accent: 'border-l-red-500'
    },
    indigo: {
      bg: 'bg-indigo-50',
      icon: 'text-indigo-600',
      border: 'border-indigo-200',
      accent: 'border-l-indigo-500'
    },
    emerald: {
      bg: 'bg-emerald-50',
      icon: 'text-emerald-600',
      border: 'border-emerald-200',
      accent: 'border-l-emerald-500'
    },
    orange: {
      bg: 'bg-orange-50',
      icon: 'text-orange-600',
      border: 'border-orange-200',
      accent: 'border-l-orange-500'
    },
    fius: {
      bg: 'bg-gradient-to-br from-[#149edb]/10 to-[#0d7bb8]/10',
      icon: 'text-[#149edb]',
      border: 'border-[#149edb]/20',
      accent: 'border-l-[#149edb]'
    }
  };

  const colors = colorClasses[color] || colorClasses.blue;

  return (
    <div 
      className={`
        bg-white rounded-xl shadow-sm hover:shadow-lg transition-all duration-300 
        border ${colors.border} ${colors.accent} ${colors.bg}
        p-6 cursor-pointer hover:scale-105 transform w-full
        ${className}
      `}
      onClick={onClick}
    >
      <div className="flex items-start justify-between mb-4">
        <div className={`p-3 rounded-xl ${colors.bg} ${colors.border} border`}>
          {Icon && <Icon className={`w-6 h-6 ${colors.icon}`} />}
        </div>
        {trend && (
          <div className={`flex items-center text-sm font-medium ${
            trend === 'up' ? 'text-green-600' : trend === 'down' ? 'text-red-600' : 'text-gray-600'
          }`}>
            <span className="mr-1">
              {trend === 'up' ? '↗' : trend === 'down' ? '↘' : '→'}
            </span>
            {trendValue && `${trendValue}%`}
          </div>
        )}
      </div>
      
      <div className="space-y-2">
        <div className="text-3xl font-bold text-gray-900">
          {value || 0}
        </div>
        <div className="text-sm font-medium text-gray-600 leading-tight">
          {title}
        </div>
        {subtitle && (
          <div className="text-xs text-gray-500">
            {subtitle}
          </div>
        )}
      </div>
    </div>
  );
};

export default StatCard;
